/**
 * Trending now — tab switching.
 *
 * Every panel is already in the document, so a tab click is a visibility
 * change and nothing more: no request, no loading state, no chance of the
 * row and the tab disagreeing about which collection is showing.
 *
 * Bound per section so the theme editor can drop in more than one, and
 * re-bound on section load so it survives an editor re-render.
 */
(() => {
  function bind(root) {
    if (!root || root.dataset.solBound === 'true') return;
    root.dataset.solBound = 'true';

    const tabs = [...root.querySelectorAll('[data-sol-tab]')];
    const panels = [...root.querySelectorAll('[data-sol-panel]')];
    if (!tabs.length) return;

    function show(id, { focus = false } = {}) {
      tabs.forEach((tab) => {
        const on = tab.dataset.solTab === id;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on && focus) tab.focus();
      });
      panels.forEach((panel) => {
        const on = panel.dataset.solPanel === id;
        panel.toggleAttribute('hidden', !on);
        // a hidden rail keeps its old scroll offset; reset so each tab
        // opens at its first product
        if (on) {
          const rail = panel.querySelector('[data-sol-rail]');
          if (rail) rail.scrollLeft = 0;
        }
      });
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => show(tab.dataset.solTab));
    });

    // left/right arrows move between tabs, as a tablist should
    root.querySelector('[role="tablist"]')?.addEventListener('keydown', (event) => {
      const step = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
      if (!step) return;
      event.preventDefault();
      const current = tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true');
      const next = (current + step + tabs.length) % tabs.length;
      show(tabs[next].dataset.solTab, { focus: true });
    });
  }

  function bindAll(scope) {
    (scope || document).querySelectorAll('[data-sol-trending]').forEach(bind);
  }

  bindAll();
  document.addEventListener('shopify:section:load', (event) => bindAll(event.target));
})();
